var _path, _path2, _path3, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaceRestorationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8503 14.3978C14.0105 15.0204 13.0249 15.3496 12.0002 15.3496C10.9754 15.3496 9.98987 15.0204 9.14998 14.3978C8.7786 14.1226 8.25417 14.2003 7.9789 14.572C7.70362 14.9434 7.78132 15.4678 8.15304 15.7431C9.2836 16.5809 10.6141 17.024 12.0005 17.024C13.3869 17.024 14.7174 16.5809 15.848 15.7431C16.2193 15.4678 16.2974 14.9434 16.0221 14.572C15.7468 14.2006 15.2224 14.1226 14.851 14.3978H14.8503Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3486 10.6054C15.965 10.6054 16.4647 9.85575 16.4647 8.931C16.4647 8.00625 15.965 7.25659 15.3486 7.25659C14.7321 7.25659 14.2324 8.00625 14.2324 8.931C14.2324 9.85575 14.7321 10.6054 15.3486 10.6054Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.65083 10.6054C9.26727 10.6054 9.76699 9.85575 9.76699 8.931C9.76699 8.00625 9.26727 7.25659 8.65083 7.25659C8.03439 7.25659 7.53467 8.00625 7.53467 8.931C7.53467 9.85575 8.03439 10.6054 8.65083 10.6054Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.9,
    y: 0.956641,
    width: 22.2,
    height: 22.2,
    rx: 6.1,
    stroke: "white",
    strokeWidth: 1.8
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceRestorationIcon);
export default __webpack_public_path__ + "static/media/FaceRestorationIcon.3042132564b4ba7b1e0c2cc1701824e3.svg";
export { ForwardRef as ReactComponent };